module.exports = __webpack_public_path__ + "img/rock_pile_small.bc17afab.png";